import { css } from '@flipster/styled-system/css';
import { flex } from '@flipster/styled-system/patterns';

export const formItem = css({ py: 8, mb: 8 });
export const wrapper = css({
  maxW: { base: 480, tablet: 358 },
  py: { base: 32, tablet: 120 },
  px: { base: 16, tablet: 0 },
  my: 0,
  mx: 'auto',
});
export const header = flex({ justify: 'between', mb: 32 });
export const h1 = css({ textStyle: 'Display/XL', color: 'inverse.white', whiteSpace: 'pre-line' });
export const divider = css({
  textStyle: 'Text/S/Regular',
  my: 24,
  color: 'content.default.level-3',
  textAlign: 'center',
});
export const socialButtonGroup = flex({ flexDirection: 'column', gap: 8 });
